var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-offers-and-best-sellers"},[_vm._l((_vm.filters),function(filter){return [_c('section-offer-day',{key:filter.id,attrs:{"title":filter.title,"products":_vm.productsByFilters.filter(function (p) { return p.filters.find(function (f) { return f === filter.id; }) === filter.id; })}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b724fcea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/market-place/section-offers-and-best-sellers.vue
// module id = 848
// module chunks = 4